import { types } from './constants';

export const startLoading = () => ({
  type: types.LOADER_START_LOADING,
});

export const stopLoading = () => ({
  type: types.LOADER_STOP_LOADING,
});
